<template>
  <v-flex
    class="sfh-login-header text-xs-center"
    :class="headerClass">

    <v-layout
      v-if="!isAuth && isCompactHeader"
      :style="isCompactHeader && {height: headerHeight}"
      row align-center justify-center>
      <v-flex xs1></v-flex>
      <v-flex xs10>
        <router-link class="d-flex ml-1 router-link-active"  to="/">
          <img
            height="50"
            width="50"
            :src="appIcon"
            style="cursor:pointer;"
            :alt="appName" />

        </router-link>
        <h2
          class="white--text font-weight-regular line-height-1 pt-2"
          v-text="appName"/>
      </v-flex>
      <v-flex xs1>
        <v-toolbar-side-icon
          class="text-shadow" dark
          @click.stop="$store.commit('toggleGuestLeftDrawer', !guestLeftDrawer)"
        ></v-toolbar-side-icon>
      </v-flex>
    </v-layout>

    <!-- For Sticky top --->
    <v-layout  v-if="!isAuth && !isCompactHeader" row align-center justify-center>
      <v-flex xs2 text-xs-left>
        <router-link class="d-flex ml-1 router-link-active"  to="/">
          <img :src="appIcon"
               height="50"
               width="50"
               :alt="appName">
        </router-link>
      </v-flex>
      <v-flex xs8>
        <h2
          :class="titleClass()"
          class="white--text font-weight-regular float-left"
          :style="titleStyle()"><span v-text="title"/>
        </h2>
      </v-flex>
      <v-flex xs2 text-xs-right>
        <v-toolbar-side-icon  class="text-shadow"  dark  @click.stop="$store.commit('toggleGuestLeftDrawer', !guestLeftDrawer)"
        ></v-toolbar-side-icon>
      </v-flex>
    </v-layout>

    <!--- USER LOGGED IN --->
    <div v-if="isAuth && isCompactHeader">
      <v-layout
        row wrap align-center justify-center user-logged-in
        :style="{height: headerHeight}">
        <v-flex xs2>
          <router-link class="d-flex ml-1 router-link-active"  to="/">
            <img
              height="50"
              width="50"
              :src="appIcon"
              style="cursor:pointer;"
              :alt="appName" />
          </router-link>
        </v-flex>
        <v-flex xs8></v-flex>
        <v-flex xs2 text-xs-right>
          <v-toolbar-side-icon  class="text-shadow"  dark  :class="currentStep === 3 ? 'current-step':''"
                                @click.stop="$store.commit('toggleRightDrawer', !rightDrawer)"
          ></v-toolbar-side-icon>
        </v-flex>
      </v-layout>
      <v-flex xs12 style="margin-top:-30px; height:60px;z-index: 1;position:relative; ">
          <div class="user-avatar elevation-10"
              :style="{ backgroundImage: 'url(' + $store.getters['user/avatar'] + ')',height:'90px',width:'90px' }"></div>
      </v-flex>
    </div>
    <!-- For Sticky top --->
    <v-layout  v-if="isAuth && !isCompactHeader" row align-center justify-center py-2>
      <v-flex xs2 text-xs-left>
        <router-link class="d-flex ml-1 router-link-active"  to="/">
          <img :src="appIcon"
               height="50"
               width="50"
               :alt="appName" />
        </router-link>
      </v-flex>
      <v-flex xs8>
        <h2  class="white--text font-weight-regular float-left mt-2 line-height-1"
             style="text-align: left;" v-html="title"></h2>

      </v-flex>
      <v-flex xs2 text-xs-right>
        <v-toolbar-side-icon  dark   class="text-shadow"  :class="currentStep === 3 ? 'current-step':''"
                              @click.stop="$store.commit('toggleRightDrawer', !rightDrawer)"
        ></v-toolbar-side-icon>

      </v-flex>
    </v-layout>


    <navigation-menu></navigation-menu>
    <guest-left-navigation-menu></guest-left-navigation-menu>
  </v-flex>

</template>

<script>
  import NavigationMenu from './NavigationMenu'
  import GuestLeftNavigationMenu from './GuestLeftNavigationMenu'
  import { DEVICE_WIDTH, SINGLE_LINE_MAX_TITLE_LEN } from '@/mixins/constants'

  const { I_PHONE_5, I_PHONE_X, I_PAD } = DEVICE_WIDTH

  export default {
    name: 'Header',
    components: {
      GuestLeftNavigationMenu,
      NavigationMenu
    },
    props: {
      className: {
        default: '',
        type: String
      },
      headerHeight: {
        default: '70px',
        type: String
      }
    },
    data () {
      return {
        clipped: false,
        hasAvatar: true,
        appName: process.env.APP_NAME,
        appIcon: require('@/assets/logos/' + process.env.APP_ICON)
      }
    },
    computed: {
      headerClass () {
        if (this.className) {
          return this.className
        } else
        if (this.isAuth) {
          if (this.isCompactHeader) {
            return 'pa-1'
          } else {
            return 'pa-1 text-xs-left'
          }
        } else {
          if (this.isCompactHeader) {
            return 'px-5 pt-2 pb-3'
          } else {
            const py = this.appWidth <= I_PHONE_5 ? 'py-1' : 'py-3'
            return `${py} text-xs-left`
          }
        }
      },
      title: {
        get: function () {
          let title = typeof this.$route.meta.pageTitle !== 'undefined' ? this.$route.meta.pageTitle : ''
          if (this.$route.name === 'ProgramLevels') {
            title = this.$store.getters.getPageTitle
          }

          return title
        },
        set: function () {
        }
      },
      isCompactHeader: {
        get: function () {
          return this.$store.getters.getIsCompactHeader
        },
        set: function (val) {
          this.$store.commit('setIsCompactHeader', val)
        }
      },
      currentStep: {
        get: function () {
          return this.$store.getters.getTourCurrentStep
        },
        set: function () {
          // setting db object
        }
      },
      isAuth () {
        return this.$auth.check()
      },
      userDetails () {
        return this.$store.getters['user/getUserDetails']
      },
      avatarLetters () {
        return this.$store.getters['user/avatarLetters']
      },
      rightDrawer: {
        get: function () {
          return this.$store.getters.rightDrawer
        },
        set: function (value) {
          this.$store.commit('toggleRightDrawer', value)
        }
      },
      guestLeftDrawer: {
        get: function () {
          return this.$store.getters.guestLeftDrawer
        },
        set: function (value) {
          this.$store.commit('toggleGuestLeftDrawer', value)
        }
      },
      appWidth () {
        return this.$store.getters.getAppWidth
      }
    },
    created () {
    },
    methods: {
      titleClass () {
        return this.title.length > SINGLE_LINE_MAX_TITLE_LEN ? 'mt-2 line-height-1' : 'line-height-1-2'
      },
      titleStyle () {
        const fontSize = this.appWidth >= I_PAD ? '1.5em' : '1.4em'
        const marginLeft = this.appWidth < I_PHONE_X ? '10px' : 'auto'
        return {
          textAlign: 'left',
          fontSize,
          marginLeft
        }
      },
      openRoute (route) {
        if (route === '/') {
          const route = Object.keys(this.userDetails).length > 0 ? 'Programs' : 'Home'
          this.$router.push({name: route})
        } else {
          this.$router.push({name: route})
        }
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/layouts/Header.vue